export * from './account.controller';
import account1 from './account1.html';
import account2 from './account2.html';
import account3 from './account3.html';
import login from './login.html';

export { account1, account2, account3, login }
